export enum ReceiptType {
    PAID = 'PAID',
    RECEIVED = 'RECEIVED',
}
